import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import SupplierEdit from '@components/shared/suppliers/SupplierEdit';
import { useOperatorSupplierService } from '@hooks/operator/suppliers/useOperatorSupplierService';

function SupplierNewInner() {
  const supplierService = useOperatorSupplierService();
  return <SupplierEdit service={supplierService} role="operator" />;
}

export default function OperatorSupplierNew() {
  // 新增模式：先選擇 merchant
  return (
    <MerchantSelect>
      <SupplierNewInner />
    </MerchantSelect>
  );
}
